import React, { useEffect, useState } from "react";
import styles from "./StepTwo.module.css";
import Header from "../../Header/Header";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GeoSearch from "../../../components/PropertyComponent/GeoSearch";
import { AiOutlineSearch } from "react-icons/ai";
import ProgressBar from "../GeneralInformationForm/ProgressBar";
import { showErrorToast } from "../../utils";
const TitleStepTwo = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // State variables to capture form input
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [unitNumber, setUnitNumber] = useState("");
    const storageInfo = JSON.parse(sessionStorage.getItem("insuranceInfo"));

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent the default form submission behavior

        // Validate form inputs
        if (!(await validateForm())) return;

        const authUserToken = localStorage.getItem("authUser");
        const authUser = authUserToken ? authUserToken.replace(/^"|"$/g, "") : "";

        try {
            sessionStorage.setItem("insuranceInfo", JSON.stringify({ ...storageInfo, propertyInfo: { address, state, city, zipCode } }));

            navigate("/get-title/step-3", { state: { ...location.state, propertyInfo: { address, state, city, zipCode } } });
        } catch (error) {
            console.error("Error submitting the form:", error);
            showErrorToast("An error occurred. Please try again.");
        }
    };

    useEffect(() => {
        document.title = `Title Services | ${config.get("COMPANY_NAME")}`;
    }, []);

    const validateForm = async () => {
        if (!address || !city || !state || !zipCode) {
            showErrorToast("Please fill in all fields.");
            return false;
        }

        return true; // If everything is valid
    };
    const getAddressComponent = (addressComponents, type) => {
        const component = addressComponents.find((c) => c.types.includes(type));
        return component ? component.long_name : "";
    };
    const isValidCity = (city) => /^[a-zA-Z\s-]+$/.test(city.trim());

    return (
        <div className={`${styles.container} tw-bg-background_color`}>
            <main className={`${styles.mainContent} tw-pt-[55px] `}>
                <Header title="Apply For Title" />
                <section className={`${styles.formSection} tw-items-center  tw-overflow-y-auto`}>
                    {/* <ProgressBar currentStep={2} totalSteps={3} /> */}
                    <div className={`${styles.formContainer} tw-w-full max-lg:tw-w-[80%]`}>
                        <h1 className={styles.formTitle}>Tell Us About Your Home</h1>
                        <p className={`${styles.formDescription} tw-text-justify`}>
                            Accurate property details are crucial for a comprehensive title search and legal services. The information you provide
                            will help our experts conduct thorough research and offer tailored solutions to protect your interests.
                        </p>
                        <form className={styles.generalForm} onSubmit={handleSubmit}>
                            <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Property Address</label>
                                    {/* <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                    /> */}
                                    <div className="tw-filter-search-wrapper tw-w-full tw-select-filter tw-bg-[#101010]  tw-rounded-lg tw-text-sm tw-text-gray-700 tw-flex-grow">
                                        <GeoSearch
                                            onBoundingBoxUpdate={(boundingBox, place) => {
                                                setAddress(place.formatted_address);
                                                setCity(getAddressComponent(place.address_components, "locality"));
                                                setState(getAddressComponent(place.address_components, "administrative_area_level_1"));
                                                setZipCode(getAddressComponent(place.address_components, "postal_code"));
                                            }}
                                            deleteSearchLocation={() => {}}
                                            isSimple={true}
                                            setAddress={setAddress}
                                            address={address}
                                            // className="search-box-filter"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>City</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your City"
                                        required={true}
                                        value={city}
                                        onChange={(e) => {
                                            if (isValidCity(e.target.value)) {
                                                setCity(e.target.value);
                                            }
                                        }}
                                    />
                                </div>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>State</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your State"
                                        value={state}
                                        onChange={(e) => {
                                            if (isValidCity(e.target.value)) {
                                                setState(e.target.value);
                                            }
                                        }}
                                    />
                                </div>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Zip Code</label>
                                    <input
                                        type="text"
                                        className={styles.fieldInput}
                                        placeholder="Enter your State"
                                        required={true}
                                        value={zipCode}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 5) {
                                                setZipCode(e.target.value);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <p className="tw-text-secondary tw-italic tw-text-[12px]">
                                Using the address autocomplete feature can save time and ensure accuracy.{" "}
                            </p>
                            <div className="tw-flex tw-justify-center">
                                <button
                                    type="submit"
                                    className={`${styles.submitButton} tw-bg-primary tw-text-white hover:tw-bg-primary_hover tw-w-fit`}
                                >
                                    Next: Coverage Preferences{" "}
                                </button>
                            </div>
                        </form>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default TitleStepTwo;
